var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#242937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0452 6.11626C11.4752 5.70526 10.7592 5.49976 9.89722 5.49976C9.24172 5.49976 8.68822 5.64426 8.23872 5.93376C7.52522 6.38676 7.14622 7.15626 7.10022 8.24126H8.75372C8.75372 7.92476 8.84622 7.62126 9.03022 7.32726C9.21472 7.03426 9.52772 6.88776 9.96922 6.88776C10.4182 6.88776 10.7277 7.00676 10.8962 7.24426C11.0657 7.48276 11.1502 7.74626 11.1502 8.03526C11.1502 8.28726 11.0242 8.51776 10.8717 8.72676C10.7808 8.8565 10.6692 8.97037 10.5412 9.06376C10.5412 9.06376 9.64472 9.63876 9.25122 10.1008C9.02322 10.3683 9.00272 10.7698 8.98222 11.3448C8.98122 11.3858 8.99672 11.4708 9.13972 11.4708H10.4252C10.5532 11.4708 10.5797 11.3763 10.5812 11.3338C10.5902 11.1248 10.6132 11.0173 10.6517 10.8963C10.7237 10.6678 10.9207 10.4688 11.1412 10.2968L11.5962 9.98326C12.0072 9.66276 12.3347 9.40026 12.4797 9.19426C12.7267 8.85626 12.9007 8.43926 12.9007 7.94426C12.9002 7.13676 12.6152 6.52826 12.0452 6.11626ZM9.87072 12.4618C9.30122 12.4443 8.83122 12.8388 8.81322 13.4568C8.79572 14.0738 9.24222 14.4823 9.81222 14.4988C10.4067 14.5163 10.8642 14.1353 10.8827 13.5173C10.8997 12.8993 10.4657 12.4793 9.87072 12.4618Z",
    fill: "#8595C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkBlue);
export default __webpack_public_path__ + "static/media/question-mark-blue.c379e862de2abe1aec38189a85be4233.svg";
export { ForwardRef as ReactComponent };